const PROFILES = [
  { id: 1, description: 'Administrador' },
  { id: 2, description: 'Corban' },
  { id: 3, description: 'Cliente' }
];

const REGISTER_TYPE = {
  EXCHANGE: { id: 1, description: 'Pessoa física câmbio turismo' },
  BASIC_REMITTANCE: { id: 2, description: 'Pessoa física básico' },
  COMPLETE_REMITTANCE: { id: 3, description: 'Pessoa física completo' },
  LEGAL_PERSON: { id: 4, description: 'Pessoa jurídica' }
};

// In the future, save this information in database

const PERSON_TYPE = [
  { id: 1, description: 'Pessoa jurídica' },
  { id: 2, description: 'Pessoa física' }
];

const MARITAL_STATUS = {
  SINGLE: { id: 1, description: 'Solteiro(a)' },
  MARRIED: { id: 2, description: 'Casado(a)' },
  DIVORCED: { id: 3, description: 'Divorciado(a)' },
  STABLE_UNION: { id: 4, description: 'União estável' },
  WIDOWED: { id: 5, description: 'Viúvo(a)' }
};

const MARRIAGE_SYSTEM = {
  PARTIAL_COMMUNION_OF_GODS: { id: 1, description: 'Comunhão parcial de bens' },
  UNIVERSAL_COMMUNION_OF_GODS: { id: 2, description: 'Comunhão universão de bens' },
  STABLE_UNION: { id: 3, description: 'União estável' },
  SEPARATION_OF_GODS: { id: 4, description: 'Separação de Bens' },
  SEPARATION_OF_GODS_FREEDOM_OF_CHOICE: {
    id: 5,
    description: 'Separação de Bens: Liberdade de escolha'
  },
  PARTIAL_COMMUNION_OF_GODS_JUSTICE_AND_UNION: {
    id: 6,
    description: 'Comunhão parcial de bens: Justiça e união'
  }
};

import { DOCUMENT_TYPE } from '../../../common/constants/generic/customerDocuments.js';

const IDENTIFICATION_DOCUMENT_TYPE = {
  RG: { id: 1, description: 'RG' },
  CNH: { id: 2, description: 'CNH' },
  Funcional: { id: 3, description: 'Funcional' },
  'RNE/RNM': { id: 4, description: 'RNE/RNM' },
  Passaporte: { id: 5, description: 'Passaporte' }
};

const LIST_IDENTIFICATION_DOCUMENT_TYPE = [
  IDENTIFICATION_DOCUMENT_TYPE.RG,
  IDENTIFICATION_DOCUMENT_TYPE.CNH,
  IDENTIFICATION_DOCUMENT_TYPE.Funcional,
  IDENTIFICATION_DOCUMENT_TYPE['RNE/RNM'],
  IDENTIFICATION_DOCUMENT_TYPE.Passaporte
];

// const NATIONAL_BANKS = [
//   { 'id': 1, 'description': 'national bank 1' },
//   { 'id': 2, 'description': 'national bank 2' },
// ];

// const INTERNATIONAL_BANKS = [
//   { 'id': 1, 'description': 'international bank 1' },
//   { 'id': 2, 'description': 'international bank 2' },
// ];

const FORM_OF_INCOPORATION = [
  { id: 1, description: 'MEI' },
  { id: 2, description: 'ME' },
  { id: 3, description: 'Simples Nacional' },
  { id: 4, description: 'LTDA' },
  { id: 5, description: 'S/A' }
];

// Helper IDs for specific forms of incorporation
const SA_FORM_OF_INCOPORATION_ID = FORM_OF_INCOPORATION.find(
  (item) => item.description === 'S/A'
)?.id;

const OPERATING_MODE = [
  { id: 1, description: 'Por conta própria' },
  {
    id: 2,
    description:
      'Por conta e ordem de terceiros. Neste caso, informe o nome e CNPJ do principal prestador de serviços. Utilize o campo "informações adicionais"'
  }
];

const HABILITATION_MODE = [
  { id: 1, description: 'Limitado (antigo simplificado)' },
  { id: 2, description: 'Ilimitado (antigo ordinário)' },
  { id: 3, description: 'Expressa' }
];

const PAYMENT_MODE = [
  { id: 1, description: 'Antecipado/A vista (Sem DI)' },
  { id: 2, description: 'Pronta (Com DI)' },
  { id: 3, description: 'Ambos' }
];

const BUSINESS_PURPOSE_TYPE = [
  { id: 1, description: 'Câmbio Comercial (Importação e Exportação)' },
  {
    id: 2,
    description:
      'Câmbio, Transferências Unilaterais e Turismo (Diponibilidade, Patrimônio, Manut. Res., etc'
  },
  { id: 3, description: 'Câmbio Financeiro (Investimento, Empréstimos, Juros, Serviços, etc' },
  { id: 4, description: 'Conta Corrente Não Residente (TIR)' },
  { id: 5, description: 'Hedge e Derivativos no Exterior' },
  { id: 6, description: 'Conta Corrente em Moeda Estrangeira' },
  { id: 7, description: 'Outros Produtos e Serviços (Informar)' }
];

const CORRESPONDING = [
  { id: 0, name: 'João da Silva' },
  { id: 1, name: 'Maria da Silva' },
  { id: 2, name: 'Pedro da Silva' }
];

const BANKS = [
  { id: 0, description: 'Banco BS2' },
  { id: 1, description: 'Banco Ourinvest' },
  { id: 2, description: 'Treviso Corretora de Câmbio S/A' }
];

const ACCESS_ROUTES = {
  DASHBOARD: {
    description: 'Dashboard',
    profiles: [1, 2]
  },
  USERS: {
    description: 'Usuários',
    profiles: [1]
  }
};

const ASSETS = [
  { id: 0, description: 'Até R$ 100 Mil Reais' },
  { id: 1, description: 'Até R$ 300 Mil Reais' },
  { id: 2, description: 'Até R$ 500 Mil Reais' },
  { id: 3, description: 'Até R$ 1 Milhão de Reais' },
  { id: 4, description: 'Acima de R$ 1 Milhão de Reais' }
];

const LIQUIDATION = [
  { id: 1, description: 'D+0/D+0' },
  { id: 2, description: 'D+0/D+1' },
  { id: 3, description: 'D+0/D+2' },
  { id: 4, description: 'D+1/D+1' },
  { id: 5, description: 'D+1/D+2' },
  { id: 6, description: 'D+2/D+2' }
];

// Opções de liquidação para operações de entrada (compra de moeda estrangeira).
// ME (moeda estrangeira) é sempre D+0 — dinheiro já está na conta do banco.
// BRL pode ser pago em datas futuras conforme interesse do cliente.
const LIQUIDATION_ENTRY = [
  { id: 1, description: 'D+0/D+0' },
  { id: 7, description: 'D+1/D+0' },
  { id: 8, description: 'D+2/D+0' },
  { id: 9, description: 'D+3/D+0' }
];

const OPERATION_DOCUMENT_TYPES = {
  DIDUE: {
    id: 1,
    description: 'DUIMP/DU-E'
  },
  SWIFT: {
    id: 2,
    description: 'SWIFT'
  },
  CC: {
    id: 3,
    description: 'Contrato de Câmbio'
  },
  COMPROVANTE: {
    id: 4,
    description: 'Comprovante de Pagamento'
  },
  OUTROS: {
    id: 5,
    description: 'Outros'
  },
  BOLETO_BANCARIO: {
    id: 6,
    description: 'Boleto Bancário'
  },
  AUTORIZACAO: {
    id: 7,
    description: 'Autorização de entrega'
  },
  INVOICE: {
    id: 8,
    description: 'Invoice'
  },
  BLAWB: {
    id: 9,
    description: 'BL / AWB'
  },
  CONTRATOS_DIVERSOS: {
    id: 10,
    description: 'Contratos diversos'
  },
  CONTRATO_HEDGE: {
    id: 11,
    description: 'Contrato de Hedge'
  },
  PROPOSTA_OPERACAO: {
    id: 12,
    description: 'Proposta de Operação'
  }
};

const OPERATION_DOCUMENT_TYPE_LIST = Object.values(OPERATION_DOCUMENT_TYPES);

const EXCHANGE_TOURISM_DOCUMENT_TYPES = [
  OPERATION_DOCUMENT_TYPES.PROPOSTA_OPERACAO,
  OPERATION_DOCUMENT_TYPES.COMPROVANTE,
  OPERATION_DOCUMENT_TYPES.AUTORIZACAO,
  OPERATION_DOCUMENT_TYPES.OUTROS
];

const AUTHORIZATION_TYPE = {
  PER_OPERATION: { id: 1, description: 'Por operação' },
  SIX_MONTHS: { id: 2, description: 'Por 6 meses' }
};

const AUTHORIZATION_TYPE_LIST = Object.values(AUTHORIZATION_TYPE);

const OPERATION_TYPE = {
  REMMITANCE: {
    id: '1',
    description: 'Remmitance'
  },
  EXCHANGE: {
    id: '2',
    description: 'Exchange'
  },
  BOTH: {
    id: '3',
    description: 'Both'
  }
};

const OPERATION_CALCULATION_TYPE = {
  CURRENCY_AMOUNT: {
    id: '1',
    description: 'Valor M.E.'
  },
  BRL_AMOUNT: {
    id: '2',
    description: 'Valor Real'
  }
};

const DELIVERY_TYPE = {
  WITHDRAWAL: {
    id: '1',
    description: 'Retirada na Loja'
  },
  DELIVERY: {
    id: '2',
    description: 'Delivery'
  },
  BOTH: {
    id: '3',
    description: 'Ambas'
  }
};

const PAYMENT_METHOD = {
  PIX: {
    id: 1,
    description: 'Pix'
  },
  TED_DOC: {
    id: 2,
    description: 'TED/DOC'
  },
  BOLETO: {
    id: 3,
    description: 'Boleto'
  },
  CREDIT_CARD: {
    id: 4,
    description: 'Cartão de Crédito'
  },
  CASH: {
    id: 5,
    description: 'Dinheiro'
  }
};

const CUSTOMER_EXCHANGE_BANK_STATUS_CORES = {
  CADASTRO_ENVIADO: 'customerExchangeBankWorkflowStatusCadastroEnviado',
  CADASTRO_ANDAMENTO: 'customerExchangeBankWorkflowStatusCadastroEmAndamento',
  CADASTRO_FINALIZADO: 'customerExchangeBankWorkflowStatusCadastroFinalizado',
  CADASTRO_ANALISE: 'customerExchangeBankWorkflowStatusCadastroEmAnalise',
  CADASTRO_PENDENCIA_DOCUMENTAL: 'customerExchangeBankWorkflowStatusPendenciaDocumental',
  ENVIADO_AO_BANCO: 'customerExchangeBankWorkflowStatusEnviadoAoBanco',
  PLD_COMPLIANCE: 'customerExchangeBankWorkflowStatusPldCompliance',
  CADASTRO_APROVADO: 'customerExchangeBankWorkflowStatusCadastroAprovado',
  CADASTRO_ENCERRADO: 'customerExchangeBankWorkflowStatusEncerrado',
  CADASTRO_RECUSADO: 'customerExchangeBankWorkflowStatusCadastroRecusado',
  ATUALIZACAO_CADASTRAL: 'customerExchangeBankWorkflowStatusAtualizacaoCadastral',
  PENDENCIA_BANCO: 'customerExchangeBankWorkflowStatusPendenciaBanco'
};

const COLUMS_CUSTOMER_EXCHANGE_BANKS = [
  {
    text: 'Criado em',
    value: 'customer.createdAt',
    align: 'left',
    sortable: true,
    width: '150px'
  },
  {
    text: 'Última alteração',
    value: 'customer.updatedAt',
    align: 'left',
    sortable: true,
    width: '150px'
  },
  {
    text: 'Nome / Razão social',
    value: 'customer.customerNameOrCompanyName',
    align: 'left',
    sortable: true,
    width: '300px'
  },
  {
    text: 'Perfil do cadastro',
    value: 'customer.registerType.description',
    align: 'left',
    sortable: true,
    width: '150px'
  },
  {
    text: 'Banco',
    value: 'bank.companyName',
    align: 'left',
    sortable: true,
    width: '200px'
  },
  {
    text: 'Corban',
    value: 'customer.correspondent.name',
    align: 'left',
    sortable: true,
    width: '170px'
  },
  {
    text: 'Email',
    value: 'customer.email',
    align: 'left',
    sortable: true,
    width: '200px',
    cellClass: 'email-column'
  },
  {
    text: 'Fluxo',
    value: 'statusDescription',
    align: 'center',
    width: '190px'
  },
  { text: 'Ações', value: 'actions', align: 'center', sortable: false, width: '70px' }
];

const FILE_TYPE = {
  CUSTOMER_DOCUMENT: 'customerDocument',
  CUSTOMER_OPERATIONAL_DOCUMENT: 'customerOperationalDocument',
  OPERATION_DOCUMENT: 'operationDocument'
};

const TEMPLATE_TYPES = {
  EMAIL: {
    id: '1',
    description: 'E-mails'
  },
  OUTROS: {
    id: '3',
    description: 'Outros'
  },
  FICHA_CLIENTE: {
    id: '4',
    description: 'Ficha do Cliente'
  },
  MENSAGEM_OPERACAO: {
    id: '5',
    description: 'Mensagem de Operação'
  },
  DOCUMENTOS_EMITIDOS: {
    id: '6',
    description: 'Documentos Emitidos'
  }
};

const PAGINATION_DEFAULT = 30;
const ITEMS_PER_PAGE_DEFAULT = { itemsPerPageOptions: [5, 10, 30, 50, -1] };

const CURRENCIES = [
  'USD',
  'EUR',
  'GBP',
  'JPY',
  'CHF',
  'CAD',
  'AUD',
  'NZD',
  'CNY',
  'HKD',
  'SGD',
  'MXN',
  'ARS',
  'UYU',
  'CLP',
  'PEN',
  'BOB',
  'COP',
  'ZAR',
  'AED'
];

const HOME_EXCHANGE_SPREADS = [
  { code: 'USD', spreadBuy: 4.38, spreadSell: 6.5 },
  { code: 'EUR', spreadBuy: 4.58, spreadSell: 6.7 },
  { code: 'GBP', spreadBuy: 9.38, spreadSell: 10.9 },
  { code: 'CAD', spreadBuy: 14.38, spreadSell: 10.9 },
  { code: 'AUD', spreadBuy: 13.38, spreadSell: 11.0 },
  { code: 'CLP', spreadBuy: 20.38, spreadSell: 23.5 },
  { code: 'CHF', spreadBuy: 7.88, spreadSell: 19.5 },
  { code: 'MXN', spreadBuy: 24.88, spreadSell: 21.8 }
];

const EMAIL_SENT_STATUS_ID = 1;

const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503
};

export {
  ACCESS_ROUTES,
  PROFILES,
  REGISTER_TYPE,
  PERSON_TYPE,
  MARITAL_STATUS,
  MARRIAGE_SYSTEM,
  DOCUMENT_TYPE,
  IDENTIFICATION_DOCUMENT_TYPE,
  LIST_IDENTIFICATION_DOCUMENT_TYPE,
  CORRESPONDING,
  BANKS,
  FORM_OF_INCOPORATION,
  SA_FORM_OF_INCOPORATION_ID,
  BUSINESS_PURPOSE_TYPE,
  PAYMENT_MODE,
  HABILITATION_MODE,
  OPERATING_MODE,
  ASSETS,
  LIQUIDATION,
  LIQUIDATION_ENTRY,
  OPERATION_DOCUMENT_TYPE_LIST,
  OPERATION_DOCUMENT_TYPES,
  EXCHANGE_TOURISM_DOCUMENT_TYPES,
  AUTHORIZATION_TYPE,
  AUTHORIZATION_TYPE_LIST,
  OPERATION_TYPE,
  OPERATION_CALCULATION_TYPE,
  DELIVERY_TYPE,
  PAYMENT_METHOD,
  CUSTOMER_EXCHANGE_BANK_STATUS_CORES,
  FILE_TYPE,
  TEMPLATE_TYPES,
  PAGINATION_DEFAULT,
  ITEMS_PER_PAGE_DEFAULT,
  COLUMS_CUSTOMER_EXCHANGE_BANKS,
  CURRENCIES,
  HOME_EXCHANGE_SPREADS,
  EMAIL_SENT_STATUS_ID,
  HTTP_STATUS
};
